export default __webpack_public_path__ + "static/media/traslado.d5ff5891.svg";